/*
 * @Author: your name
 * @Date: 2020-10-22 14:02:44
 * @LastEditTime: 2021-11-26 14:28:10
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ksh-factory-vue/src/router/index.js
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
const Index = resolve => require(['@/views/index/Index'], resolve)
const DemandList = resolve => require(['@/views/demand/DemandList'], resolve)
const DemandDetail = resolve => require(['@/views/demand/DemandDetail'], resolve)
const About = resolve => require(['@/views/about/About'], resolve)
const ArticleList = resolve => require(['@/views/article/ArticleList'], resolve)
const ArticleDetail = resolve => require(['@/views/article/ArticleDetail'], resolve)
const AppDownload = resolve => require(['@/views/down/AppDownload'], resolve)
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter);
const routes = [
  {
    path: "",
    name: "Index",
    component: Index,
    meta: {
      requiresAuth: true,
      title: "首页"
    }
  },
  {
    path: "/",
    name: "Index",
    component: Index,
    meta: {
      requiresAuth: true,
      title: "首页"
    }
  },
  {
    path: "/index",
    name: "Index",
    component: Index,
    meta: {
      requiresAuth: true,
      title: "首页"
    }
  },
  {
    path: "/demand/list",
    name: "DemandList",
    component: DemandList,
    meta: {
      requiresAuth: true,
      title: "需求搜索"
    }
  },
  {
    path: "/demand/detail/:id",
    name: "DemandDetail",
    component: DemandDetail,
    meta: {
      requiresAuth: true,
      title: "需求"
    }
  },
  {
    path: "/about/us",
    name: "About",
    component: About,
    meta: {
      requiresAuth: true,
      title: "关于我们"
    }
  },
  {
    path: "/article/list",
    name: "ArticleList",
    component: ArticleList,
    meta: {
      requiresAuth: true,
      title: "新闻资讯"
    }
  },
  {
    path: "/article/detail/:id",
    name: "ArticleList",
    component: ArticleDetail,
    meta: {
      requiresAuth: true,
      title: "新闻资讯"
    }
  },
  {
    path: "/app/download",
    name: "AppDownload",
    component: AppDownload,
    meta: {
      requiresAuth: false,
      title: "app下载"
    }
  },  
]
let router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
});

router.beforeEach((to, from, next) => {
  let AUTH_TOKEN = to.query.token || "";
  // if (AUTH_TOKEN) {
  //   setToken(AUTH_TOKEN);
  // }
  next()
  // if (to.matched.some(record => record.meta.requiresAuth) && !getToken()) {
  //   next({
  //     path: '/error',
  //     query: {
  //       redirect: to.fullPath
  //     }
  //   })
  // } else {
  // }
});

export default router;
